export interface IBaseRole {
  groupId: number;
  groupName: string;
  groupChName?: string;
}

export interface IUserGroup extends IBaseRole {
  allowed?: boolean;
  change?: boolean;
}

export interface IBaseMenu {
  menuId: number;
  menuName: string;
  defaultPage?: boolean;
}

export interface IUserMenu extends IBaseMenu {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  email?: any;
  allowed?: boolean;
  status?: number;
  default?: boolean;
  change?: boolean;
}

export interface IHomeMenu {
  frontApiName: string;
  apiName: string;
  menuId: number;
  menuName: string;
}

export type CurrentUserInfo = {
  id: string;
  name: string;
  userId: number;
  userName: string;
  email?: string;
  groups: IUserGroup[];
  menus: IBaseMenu['menuName'][];
  homeMenu: IHomeMenu;
  grayscaleInfos: {
    // 灰度涉及范围：结算主体编辑、签约信息编辑、客户转移、工具类自助服务台信息修改
    modifyTask: boolean;
  };
};

export type AccessInfo = {
  id: number;
  name: string;
  email: string;
  roles: number[];
  accessRoutes: string[];
  home: string;
  company: number;
  grayscaleInfos: {
    // 灰度涉及范围：结算主体编辑、签约信息编辑、客户转移、工具类自助服务台信息修改
    modifyTask: boolean;
  };
  bvSession: string; // session 信息，传递给 AppSmith 搭建的应用，实现无感登录
  companyIds: number[]; // 所属业务单元
};

export type RegisterInfo = {
  username: string;
  contact: string;
  phone: string;
  password: string;
  rePassword: string;
  group?: string | number | string[] | number[];
};

export enum FeishuLoginStatus {
  SUCCESS = 1,
  FAIL = 0,
}

export interface FeishuLoginResp {
  data: {
    data: {
      feishu: {
        name: string;
        en_name: string;
        avatar_url: string;
        avatar_thumb: string;
        avatar_middle: string;
        avatar_big: string;
        open_id: string;
        union_id: string;
        email: string;
        enterprise_email: string;
        user_id: string;
        mobile: string;
        tenant_key: string;
        employee_no: string;
      };
      bv_crm: CurrentUserInfo;
    };
    status: FeishuLoginStatus;
    msg: string;
  };
}

export enum ThirdPartyLoginType {
  FEI_SHU = 'FEISHU',
  WE_COM = 'QYWX',
}

export interface ThirdPartyLoginResp {
  feishu?: Record<string, string>;
  qywx?: Record<string, string>;
  bv_crm: CurrentUserInfo;
}
